export type Opportunity = {
    id: number, 
    organizationId: number | null,
    organizationName: string | null,
    opportunityName: string,

    probability: number,
    bidAmount: number, 
    bidType: string, 
    category: string, 
    state:string, 
    location: string, 

    projectId: number | null, 
    projectName: string | null, 
    actualCloseDate: string,
    
    background: string,
    voidReason: string,
    validateReason: string,
    creatorId: string, 
    creatorName: string,
    createdAt: string, 
    updaterId: string,
    updaterName: string,
    updatedAt: string,
    void: "yes" | "no", 
    contacts: {label: string, value: string}[]
    users: {label: string, value: string}[]
};
export const stateOptions = ["OPEN","WON","LOST","SUSPENDED","ABANDONED"];
export const bidTypeOptions = ["Fixed Bid", "Per Day"];
export const categoryOptions = ["Locating","Locating & CCTV","Locating & Potholing","Locating & Surveying","Potholing","CCTV","CCTV & Potholing","Surveying","Scanning","SoCal Opportunities","Lunch & Learn Session","New Business","Proposal"];